import { buildOptions, getEndPoint } from '../../../utils/api-call';
import constants from './constants';
import { makeCall } from '../../../utils/request';

// const actionUpdateMFAStatus = ({commit, state, dispatch}, data) => {
//   commit(constants.MUTATION_UPDATE_MFA_TYPE, data.type);
//   return new Promise((resolve, reject) => {
//     const body = {};
//
//     if (data.changedPhone) {
//       body.phone = data.phone;
//     }
//     apiRequest(getEndPoints().mfa.updateMFAStatus.replace('{type}', data.type).replace('{flow}', data.flow), buildOptions('POST', body))
//       .then(response => {
//         resolve(response);
//       })
//       .catch(error => reject(error));
//   });
// };

// const actionUpdateMFAConfirm = ({commit, state, dispatch}, data) => {
//   return new Promise((resolve, reject) => {
//     apiRequest(getEndPoints().mfa.updateMFAConfirm.replace('{type}', data.type).replace('{flow}', data.flow), buildOptions('POST', data))
//       .then(response => {
//         resolve(response);
//       })
//       .catch(error => {
//         reject(error);
//       });
//   });
// };

const actionSendNewCodeMFA = ({commit, state, dispatch}, data) => {
  return new Promise((resolve, reject) => {
    makeCall(getEndPoint().mfa.sendNewCode, buildOptions('POST', data))
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const actionConfirmLoginMFA = ({commit, state, dispatch}, data) => {
  return new Promise((resolve, reject) => {
    makeCall(getEndPoint().mfa.confirmLogin, buildOptions('POST', data))
      .then(response => {
        resolve(response);
      })
      .catch(error => reject(error));
  });
};

export default {
  [constants.ACTION_CONFIRM_LOGIN_MFA]: actionConfirmLoginMFA,
  [constants.ACTION_SEND_NEW_CODE_MFA]: actionSendNewCodeMFA
};



// WEBPACK FOOTER //
// ./src/store/modules/mfa/actions.js